import { NgModule } from '@angular/core';
import { MailPreviewComponent } from './components/mail-preview/mail-preview.component';
import { MailPreviewContainerComponent } from './components/mail-preview-container/mail-preview-container.component';
import { MailPreviewAttachmentComponent } from './components/mail-preview-attachment/mail-preview-attachment.component';
import { MailPreviewHeaderComponent } from './components/mail-preview-header/mail-preview-header.component';
import { MailPreviewPopupComponent } from './components/mail-preview-popup/mail-preview-popup.component';
import { MailBuildResultViewService } from '../../results-views/mail/mail-build-result-view.service';
import { MailPreviewRecipientsComponent } from './components/mail-preview-recipients/mail-preview-recipients.component';
import { MailService } from './services/mail.service';
import { ResultsModule } from '../../results/results.module';

@NgModule({
  declarations: [
    MailPreviewComponent,
    MailPreviewContainerComponent,
    MailPreviewAttachmentComponent,
    MailPreviewHeaderComponent,
    MailPreviewPopupComponent,
    MailPreviewRecipientsComponent,
  ],
  imports: [ResultsModule],
  providers: [MailBuildResultViewService, MailService],
})
export class MailPreviewModule {}
